import React from 'react';
import { Hotel, MeetingRoom, KingBed, SingleBed, Weekend } from '@mui/icons-material';

export const COLORS = {
  reservation: {
    confirmed: '#4CAF50',
    pending: '#FFC107',
    cancelled: '#9E9E9E',
    noShow: '#F44336',
    checkedIn: '#2196F3',
    checkedOut: '#795548',
    arriving: '#00BCD4',
    departing: '#FF9800',
    inHouse: '#1976D2',
    waitlist: '#9C27B0'
  },
  room: {
    clean: '#4CAF50',
    dirty: '#F44336',
    inspected: '#2196F3',
    outOfOrder: '#424242',
    outOfService: '#757575',
    occupied: '#FF9800',
    vacant: '#8BC34A'
  },
  ui: {
    border: '#DCDCDC',
    gridMajor: '#BDBDBD',
    gridMinor: '#F0F0F0',
    headerBg: '#FAFAFA',
    monthHeader: '#37474F',
    weekHeader: '#607D8B',
    dayHeader: '#78909C',
    todayBg: 'rgba(33, 150, 243, 0.1)',
    weekendBg: 'rgba(0, 0, 0, 0.02)',
    selectedBg: '#E3F2FD',
    hoverBg: 'rgba(0, 0, 0, 0.04)'
  },
  text: {
    primary: '#263238',
    secondary: '#546E7A',
    disabled: '#B0BEC5',
    white: '#FFFFFF'
  }
};

export const ROOM_TYPES = {
  single: { icon: <SingleBed />, label: 'Individual' },
  double: { icon: <KingBed />, label: 'Doble' },
  suite: { icon: <Weekend />, label: 'Suite' },
  family: { icon: <MeetingRoom />, label: 'Familiar' },
  standard: { icon: <Hotel />, label: 'Estándar' }
};
